var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60449 44.7445H43.6641V6.27539H4.60449V44.7445ZM14.3719 15.8951H33.9067V35.1346H14.3719V15.8951ZM4.60449 92.8333H43.6641V54.3642H4.60449V92.8333ZM14.3719 63.984H33.9067V83.2234H14.3719V63.984ZM53.4315 6.27539V44.7445H92.4911V6.27539H53.4315ZM82.7236 35.1248H63.1889V15.8853H82.7236V35.1248ZM53.4814 54.3642H63.2489V63.984H53.4814V54.3642ZM63.2489 63.984H73.0162V73.6037H63.2489V63.984ZM53.4814 73.6037H63.2489V83.2234H53.4814V73.6037ZM73.0162 73.6037H82.7837V83.2234H73.0162V73.6037ZM82.7837 83.2234H92.551V92.8432H82.7837V83.2234ZM63.2489 83.2234H73.0162V92.8432H63.2489V83.2234ZM73.0162 54.3741H82.7837V63.9938H73.0162V54.3741ZM82.7837 63.9938H92.551V73.6135H82.7837V63.9938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.90a975814a6997134362ef401e1f5f92.svg";
export { ForwardRef as ReactComponent };